/* SAFI theme JS — menu, product form, gallery, cart */
(function () {
  'use strict';

  /* ---------- Helpers ---------- */

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ---------- Mobile menu ---------- */

  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('[data-site-nav]');
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Quantity steppers ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.quantity');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    var next = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart notification ---------- */

  var notification = document.querySelector('[data-cart-notification]');
  var notificationTimer;

  function showNotification(item, cartCount) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cartCount;
      el.classList.remove('visually-hidden');
    });
    if (!notification) return;
    var img = notification.querySelector('[data-notification-image]');
    var title = notification.querySelector('[data-notification-title]');
    var variant = notification.querySelector('[data-notification-variant]');
    if (img && item.image) {
      img.src = item.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_200x200$1$2');
      img.style.display = '';
    } else if (img) {
      img.style.display = 'none';
    }
    if (title) title.textContent = item.product_title;
    if (variant) variant.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    notification.classList.add('is-open');
    clearTimeout(notificationTimer);
    notificationTimer = setTimeout(function () {
      notification.classList.remove('is-open');
    }, 6000);
  }

  if (notification) {
    var closeBtn = notification.querySelector('[data-notification-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        notification.classList.remove('is-open');
      });
    }
  }

  /* ---------- Quick add (product cards) ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        return res.json();
      })
      .then(function (item) {
        return fetch(window.theme.routes.cart + '.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) { showNotification(item, cart.item_count); });
      })
      .catch(function () {
        window.location.href = window.theme.routes.cart;
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });

  /* ---------- Bundle offer tiles ---------- */

  document.addEventListener('click', function (e) {
    var offer = e.target.closest('[data-qty-offer]');
    if (!offer) return;
    var wrap = offer.closest('[data-product-form-wrapper]') || document;
    var qtyInput = wrap.querySelector('.quantity__input');
    if (qtyInput) {
      qtyInput.value = offer.getAttribute('data-qty-offer');
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var group = offer.closest('[data-qty-offers]');
    if (group) {
      group.querySelectorAll('[data-qty-offer]').forEach(function (o) { o.classList.remove('is-active'); });
      offer.classList.add('is-active');
    }
  });

  /* ---------- Buy it now (straight to checkout) ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    var wrap = btn.closest('[data-product-form-wrapper]');
    if (!wrap) return;
    var idInput = wrap.querySelector('[data-variant-id]');
    var qtyInput = wrap.querySelector('.quantity__input');
    if (!idInput) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'One moment…';
    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: parseInt(idInput.value, 10),
        quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        window.location.href = window.theme.routes.cart;
      });
  });

  /* ---------- Product forms ---------- */

  document.querySelectorAll('[data-product-form-wrapper]').forEach(function (wrapper) {
    var dataEl = wrapper.querySelector('[data-product-json]');
    if (!dataEl) return;

    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var form = wrapper.querySelector('form[data-product-form]');
    var idInput = wrapper.querySelector('[data-variant-id]');
    var priceCurrent = wrapper.querySelector('[data-price-current]');
    var priceCompare = wrapper.querySelector('[data-price-compare]');
    var priceBadge = wrapper.querySelector('[data-price-badge]');
    var priceWrap = wrapper.querySelector('[data-price]');
    var atcBtn = wrapper.querySelector('[data-atc-button]');
    var mainImage = wrapper.querySelector('[data-gallery-main] img');
    var thumbs = wrapper.querySelectorAll('[data-gallery-thumb]');

    function currentOptions() {
      var opts = [];
      wrapper.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
        else if (select) opts[parseInt(group.getAttribute('data-option-index'), 10)] = select.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function setActiveThumb(src) {
      thumbs.forEach(function (t) {
        var timg = t.querySelector('img');
        t.classList.toggle('is-active', !!(timg && src && timg.src.split('?')[0] === src.split('?')[0]));
      });
    }

    function updateUI(variant, syncVariantImage) {
      if (!variant) {
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Unavailable';
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceCompare) {
        priceCompare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        priceCompare.style.display = onSale ? '' : 'none';
      }
      if (priceBadge) {
        if (onSale) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          priceBadge.textContent = 'SAVE ' + pct + '%';
          priceBadge.style.display = '';
        } else {
          priceBadge.style.display = 'none';
        }
      }
      if (priceWrap) priceWrap.classList.toggle('price--on-sale', !!onSale);
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available
          ? atcBtn.getAttribute('data-label-add') || 'Add to cart'
          : 'Sold out';
      }
      if (syncVariantImage && variant.featured_image && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('width');
        mainImage.removeAttribute('height');
        setActiveThumb(variant.featured_image.src);
      }
      var url = new URL(window.location.href);
      if (url.pathname.indexOf('/products/') !== -1) {
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }

    wrapper.querySelectorAll('[data-option-index] input, [data-option-index] select').forEach(function (el) {
      el.addEventListener('change', function () {
        var group = el.closest('[data-option-index]');
        var valueLabel = group && group.querySelector('[data-option-value]');
        if (valueLabel && el.value) valueLabel.textContent = el.value;
        updateUI(findVariant(currentOptions()), true);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var timg = thumb.querySelector('img');
        if (timg && mainImage) {
          mainImage.src = timg.getAttribute('data-full') || timg.src;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('width');
          mainImage.removeAttribute('height');
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Adding…';
        }
        var formData = new FormData(form);
        fetch(window.theme.routes.cartAdd + '.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add-failed');
            return res.json();
          })
          .then(function (item) {
            return fetch(window.theme.routes.cart + '.js')
              .then(function (res) { return res.json(); })
              .then(function (cart) { showNotification(item, cart.item_count); });
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (atcBtn) {
              atcBtn.disabled = false;
              atcBtn.textContent = atcBtn.getAttribute('data-label-add') || 'Add to cart';
            }
          });
      });
    }

    /* Always open the product page on the first gallery image.
       Variant media should only take over after a customer changes an option. */
    var firstThumb = thumbs.length ? thumbs[0] : null;
    if (firstThumb && mainImage) {
      var firstThumbImage = firstThumb.querySelector('img');
      if (firstThumbImage) {
        mainImage.src = firstThumbImage.getAttribute('data-full') || firstThumbImage.src;
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('width');
        mainImage.removeAttribute('height');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        firstThumb.classList.add('is-active');
      }
    }
    updateUI(findVariant(currentOptions()) || product.variants[0], false);
  });

  /* ---------- Sticky add-to-cart ---------- */

  var sticky = document.querySelector('[data-sticky-atc]');
  var anchor = document.querySelector('[data-atc-button]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(anchor);

    var stickyBtn = sticky.querySelector('[data-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('form[data-product-form]');
        if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }
})();
